// Consistent back button + breadcrumb used by inner pages across the app.
//
// Usage:
//   <BackBar to="/jobs"  label_ar="العودة إلى الوظائف" label_en="Back to Jobs" />
//   <BackBar to="/cv"    label_ar="مركز السيرة الذاتية" label_en="Resume Center" />
//
// If `to` is omitted, falls back to browser history.

import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/App";
import { ArrowRight, ArrowLeft } from "lucide-react";

export default function BackBar({ to, label_ar, label_en, crumbs }) {
  const navigate = useNavigate();
  const { language, t } = useLanguage();
  const label = label_ar || label_en
    ? (language === "ar" ? (label_ar || label_en) : (label_en || label_ar))
    : t("رجوع", "Back");
  const Arrow = language === "ar" ? ArrowRight : ArrowLeft;
  return (
    <div className="mb-3 flex items-center gap-2 text-sm flex-wrap" data-testid="back-bar">
      <button
        onClick={() => to ? navigate(to) : navigate(-1)}
        className="inline-flex items-center gap-1.5 bg-slate-900/60 hover:bg-slate-900 border border-slate-800 hover:border-yellow-500/40 text-slate-200 rounded-full px-3 py-1.5 transition"
        data-testid="back-btn"
      >
        <Arrow size={14} className="text-yellow-400" />
        <span>{language === "ar" ? "←" : ""} {label}</span>
      </button>
      {Array.isArray(crumbs) && crumbs.length > 0 && (
        <nav className="text-[11px] text-slate-500 inline-flex items-center gap-1 flex-wrap" data-testid="breadcrumbs">
          {crumbs.map((c, i) => (
            <span key={i} className="inline-flex items-center gap-1">
              {i > 0 && <span className="text-slate-700">›</span>}
              {c.to ? (
                <button onClick={() => navigate(c.to)} className="hover:text-yellow-300">{language === "ar" ? c.ar : c.en}</button>
              ) : (
                <span className="text-slate-400">{language === "ar" ? c.ar : c.en}</span>
              )}
            </span>
          ))}
        </nav>
      )}
    </div>
  );
}
